import * as Ajax from '../ajax/Ajax';
/**
 * 配置用QRコードを取得します。
 *
 * @param offsetPosX X軸位置オフセット
 * @param offsetPosY Y軸位置オフセット
 * @param offsetPosZ Z軸位置オフセット
 * @param offsetRotY Y軸回転オフセット
 * @param fn 戻し先ファンクション
 */

export function GetQrCode(offsetPosX, offsetPosY, offsetPosZ, offsetRotY, fn) {
  Ajax.Post("PrintApi/GetQrCode", {
    offsetPosX: offsetPosX,
    offsetPosY: offsetPosY,
    offsetPosZ: offsetPosZ,
    offsetRotY: offsetRotY
  }, Ajax.ModelResult(fn));
}